import { getParameterByName } from '../utils/toSearchParams';
import { defined } from '../utils/variableEvaluation';
import { updateIntl } from 'react-intl-redux';
import { isProd, isStage } from '../constants/config';
import { setType, Types } from '../actions/typeContainer';
import { changeUsercentricsLanguage } from '../utils/usercentrics';

export function sideActions({ dispatch, getState }) {
  return (next) => (action) => {
    if (action.type === '@@intl/UPDATE') {
      document.documentElement.lang = action.payload.locale;
      changeUsercentricsLanguage(action.payload.locale);
    }

    if (action.type === '@@router/LOCATION_CHANGE') {
      const langParam = getParameterByName('lang');
      let langCode = getState().intl.locale;
      const isJourney1 = getState().app.containers.isJourney1;
      const isJourney2 = getState().app.containers.isJourney2;
      const isJourney3 = getState().app.containers.isJourney3;

      // Analytics code
      if ((isProd || isStage || true) && action.payload.location.pathname !== '/') {
        // For standalone react app dataLayer is set by GoogleTagManager component. For django embedded version it comes from django.
        (window as any).dataLayer &&
          (window as any).dataLayer.push({
            event: 'virtualPageView',
            virtualPageTitle: `${window.location.hostname}-${action.payload.location.pathname.split('/')[1]}`,
            virtualPageURL: window.location.pathname,
          });
      }

      if (action.payload.location.pathname.includes('journey3') && !isJourney3) {
        dispatch(setType(Types.journey3));
      } else if (action.payload.location.pathname.includes('journey2') && !isJourney2) {
        dispatch(setType(Types.journey2));
      } else if (action.payload.location.pathname.includes('journey1') && !isJourney1) {
        dispatch(setType(Types.journey1));
      }

      // Language change
      if (defined(langParam) && langParam !== langCode) {
        let languages = ['en', 'fr', 'it', 'de'];

        if (languages.indexOf(langCode) >= 0) {
          dispatch(
            updateIntl({
              locale: langParam,
              messages: getState().locales[langParam],
            }),
          );
        } else {
          dispatch(
            updateIntl({
              locale: langParam,
              messages: getState().locales['de'],
            }),
          );
          console.error(`${langParam} is not supported language`);
        }
      }
    }
    return next(action);
  };
}
